<template>
  <el-card>
    <h1>{{ langData.agency }}</h1>
    <!-- 搜索 -->
    <el-row class="search">
      <el-col :xs="24" :lg="5">
        <el-date-picker
          v-model="search.startDate"
          value-format="yyyy-MM-dd"
          type="date"
          style="width: 100%"
          :placeholder="langData.selectstartDate"
          :picker-options="{
            disabledDate(time) {
              if (!search.endDate) return false;
              const start = new Date(time);
              const end = new Date(search.endDate);
              // 设置为当天的零点，避免时分秒导致的误差
              start.setHours(0, 0, 0, 0);
              end.setHours(0, 0, 0, 0);
              const diff = end.getTime() - start.getTime();
              // 允许选择同一天 (diff >= 0)，并且保持不超过90天的限制
              return diff < 0 || diff > 90 * 24 * 3600 * 1000;
            }
          }"
        >
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :lg="5">
        <el-date-picker
          v-model="search.endDate" 
          value-format="yyyy-MM-dd"
          type="date"
          style="width: 100%"
          :placeholder="langData.selectendDate"
          :picker-options="{
            disabledDate(time) {
              if (!search.startDate) return false;
              const end = new Date(time);
              const start = new Date(search.startDate);
              // 设置为当天的零点，避免时分秒导致的误差
              end.setHours(0, 0, 0, 0);
              start.setHours(0, 0, 0, 0);
              const diff = end.getTime() - start.getTime();
              // 允许选择同一天 (diff >= 0)，并且保持不超过90天的限制
              return diff < 0 || diff > 90 * 24 * 3600 * 1000;
            }
          }"
        >
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :lg="13">
        <el-button type="primary" @click="query">{{
          langData.search
        }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table
        :data="list"
        style="width: 100%; margin-bottom: 20px"
        v-loading="loading"
        :class="{ ar: isAr == 2 }"
        border
      >
        <el-table-column
          min-width="110"
          prop="name"
          :label="langData.agencyName"
        >
          <template slot-scope="scope">
            <span class="notranslate">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="110"
          prop="agentId"
          :label="langData.agencyId"
        ></el-table-column>
        <el-table-column
          min-width="110"
          prop="inviteCode"
          :label="langData.inviteCode"
        >
          <template slot-scope="scope">
            <span translate="no">{{ scope.row.inviteCode }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="110"
          prop="registerHostess"
          :label="langData.registerHostess"
        ></el-table-column>
        <el-table-column
          min-width="110"
          prop="passTestHostess"
          :label="langData.reviewSuccessCount"
        ></el-table-column>
        <el-table-column
          min-width="110"
          prop="totalUSDIncome"
          :label="langData.totalUSDIncome"
        >
          <template slot-scope="scope">
            {{ `$${Math.round(scope.row.totalUSDIncome)}` }}
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-input
        style="width: 160px; margin: 0 0 20px"
        v-model="agentName"
        placeholder="agentName"
      ></el-input>
      <div>
        <el-select
          style="width: 160px"
          multiple
          collapse-tags
          v-model="agentType"
          placeholder=""
        >
          <el-option
            v-for="item in agentTypes"
            :key="item.value"
            :label="item.enName"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancel</el-button>
        <el-button type="primary" @click="create()">Create</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { getAgencyInformation } from '@/api/agency.js'
import { databaseAgent } from '@/utils/lang.js'
import { getCountryList } from '@/api/operate.js'

export default {
  data() {
    return {
      loading: false,
      list: [],
      countryList: [],
      langData: {},
      dialogVisible: false,
      isAr:parseInt(sessionStorage.getItem('lang')),
      agentType: [
        JSON.parse(sessionStorage.getItem('loginData')).agentType[0].value,
      ],
      search: {
        startDate: null,
        // countryCode: null,
        // rid: null,
        // active: null,
        endDate: null,
      },
      agentName: '',
      agentTypes: JSON.parse(sessionStorage.getItem('loginData')).agentType,
    }
  },
  created() {
    this.query()
    this.getCountryCode()
    if (sessionStorage.getItem('lang')) {
      this.langData = databaseAgent[parseInt(sessionStorage.getItem('lang'))]
    } else {
      window.sessionStorage.setItem('lang', '0')
      this.langData = databaseAgent[0]
    }
  },
  watch: {
    '$store.state.lang': function (val) {
      this.langData = databaseAgent[val]
      this.isAr = val
    },
  },
  methods: {
    // 获取国家选项
    async getCountryCode() {
      const { data: res } = await getCountryList()
      this.countryList = res.data.countryList
    },
    handleClose() {
      this.dialogVisible = false
      this.agentName = ''
      this.agentType = [this.agentTypes[0].value]
      this.agentTypes = JSON.parse(
        sessionStorage.getItem('loginData')
      ).agentType
    },
    Creates() {
      if (JSON.parse(sessionStorage.getItem('loginData')).canCreateSon == 1) {
        return true
      }
      return false
    },
    // 获取列表
    async query() {
      this.loading = true
      const { data: res } = await getAgencyInformation({...this.search})
      this.loading = false
      if (res.code !== 0)
        return this.$message({
          message: res.msg,
          center: true,
          type: 'error',
        })
      this.$message({
        message: res.msg,
        center: true,
        type: 'success',
      })
      this.list = [res.data]
    },

    // 获取创建
    async create() {
      let agentType = this.agentType.join()
      const { data: res } = await getAgencyregister({
        agentId: JSON.parse(sessionStorage.getItem('loginData')).agentId,
        agentType: agentType,
        agentName: this.agentName,
      })
      if (res.code !== 0)
        return this.$message({
          message: res.msg,
          center: true,
          type: 'error',
        })
      this.$message({
        message: res.msg,
        center: true,
        type: 'success',
      })

      this.handleClose()
      this.query()
    },
  },
}
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;
  span {
    font-size: 20px;
    font-weight: 600;
    margin-right: 15px;
    margin-left: 15px;
  }
}
</style>